module.exports = __webpack_public_path__ + "static/media/ws-berry.fc344e83.svg";